import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import MultiSelecteDropdown from "./MultiSelectDropdown";
import { formatRejectionReasons } from "../utils/formatRejectionReasons";

const CommonRejectionsReasons = ({
  selectedReasons,
  setSelectedReasons,
  onRejectionReasonChange,
  currentRejectionReason,
}) => {
  const { t } = useTranslation("general");

  const rejectionReasonOptions = [
    {
      id: 17,
      title: "uploadeInvoiceInWrongPlace",
    },
    {
      id: 16,
      title: "uploadCertifcateFromSuppliersPage",
    },
    {
      id: 22,
      title: "useEhsiblyForms",
    },
    {
      id: 13,
      title: "uploadDocsInCorrectPlaces",
    },
    {
      id: 1,
      title: "uploadMoneyTransferRequestForm",
      name: "Upload Money Transfer Request Form",
    },
    // {
    //   id: 2,
    //   title: "uploadConfirmationDocument",
    //   name: "Upload Confirmation Document",
    // },
    // {
    //   id: 3,
    //   title: "uploadFinancialTransferRequestForm",
    //   name: "Upload Financial Transfer Request Form",
    // },
    // {
    //   id: 4,
    //   title: "uploadDeclarationCommitmentForm",
    //   name: "Upload Declaration and Commitment Form",
    // },
    {
      id: 5,
      title: "totalMismatch",
    },
    {
      id: 6,
      title: "bankUpdate",
    },
    {
      id: 7,
      title: "logoConsistency",
    },
    {
      id: 8,
      title: "unclearDescription",
    },
    {
      id: 9,
      title: "settleTransfers",
    },
    {
      id: 10,
      title: "noHSCode",
    },
    {
      id: 11,
      title: "provideAdvanceDeclaration",
    },
    {
      id: 12,
      title: "noWebsiteFoundInTheInvoice",
    },
    {
      id: 14,
      title: "uploadEmailConfirmationDoc",
    },
    // {
    //   id: 19,
    //   title: "seperateThePackingListFromInvoice",
    // },
    {
      id: 20,
      title: "addPackingList",
    },
    {
      id: 21,
      title: "advanceDeclarationQuantitiesDontMatchPackingList",
    },
    {
      id: 22,
      title: "provideInvoiceWithLoadingConditions",
    },
  ];

  useEffect(() => {
    if (!onRejectionReasonChange) return;
    if (selectedReasons.length === 0) {
      onRejectionReasonChange("");
      return;
    }

    const newFormattedReasons = formatRejectionReasons(
      selectedReasons,
      t,
      currentRejectionReason?.length > 0 ? false : true,
    );

    // Combine old + new
    const combined = [currentRejectionReason, newFormattedReasons]
      .filter((text) => text && text.trim())
      .join("\n\n");

    onRejectionReasonChange(combined);
  }, [selectedReasons, t, onRejectionReasonChange]);

  return (
    <div className="u-margin--bottom_400">
      <label className="t-bold_bold">{t("commonRejectionReasons")}:</label>
      <MultiSelecteDropdown
        options={rejectionReasonOptions}
        selectedItems={selectedReasons}
        setSelectedItems={setSelectedReasons}
        placeholder="selectRejectionReasons"
        flex
        thick
      />
    </div>
  );
};

export default CommonRejectionsReasons;
